import { groupBy } from "lodash"
import { calidadDatosMapper, porcRespuestasMapper, renderForCriticalMoment } from "../dashHelper"
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar } from "../widgetsLibrary/widgetsLine"
import { commonWidgets, getCmID, jacCustomerJourneyMapper, jacGaugeCountNumberMapper, getJacCustomerJourney } from "./commonWidgetsJac"

const criticalMoments = [getCmID('koxEPC'), getCmID('koxESC'), getCmID('koxDPC'), getCmID('koxDSC')]

//agrupar por critical para obtener las metricas por critical

export default {
    title: "Demo Venta Dashboard",
    description: "Demo de Nacional Venta",
    backgroundClassName: (filters: any) => {
        return 'epsilon-hero-bg'
    },
    widgets: (filters: FiltersUI) => [
        getLineDetailedRadar({
            mainIndicator: 'CSATCONTACTO',
            radialIndicators: [
                'CSATCONTACTO',
                'epc_confort',
                'epc_entretenimiento',
                'epc_diseno_interior',
                'epc_diseno_exterior',
            ],
            radialType: 'byIndicator',
            size: [4, 3],
            title: 'widgets.snByGeo',
            criticalMomentInclude: criticalMoments,
            extraConfigs: {
                backgroundColor: 'transparent',
                theme: 'dark',
                showRadialChart: true,
                initialVisibleChart: 1,
                maxValue: 100,
            },
            groupByLevel: 2,
            useNormalizedRadial: false,
            indicatorsNames: {
                'CSATCONTACTO': 'Satisfación General',
                'epc_confort': 'Confort',
                'epc_entretenimiento': 'Entretenimiento',
                'epc_diseno_interior': 'Diseño Interior',
                'epc_diseno_exterior': 'Diseño Exterior',
            },
        }),
        //1
        {
            title: 'labels.surveys',
            type: 'label',
            size: [4, 1],
            config: { color: '#B7AADC' },
        },
        getJacCustomerJourney({
            id: 'cj-EPC',
            title: 'Estático primer contacto',
            size: [4, 2],
            indicators: [
                { name: 'CSATCONTACTO', formula: 'count-number', criticalMomentInclude: [getCmID('koxEPC')] },
                { name: 'epc_confort', formula: 'count-number', criticalMomentInclude: [getCmID('koxEPC')] },
                { name: 'epc_diseno_exterior', formula: 'count-number', criticalMomentInclude: [getCmID('koxEPC')] },
                { name: 'epc_diseno_interior', formula: 'count-number', criticalMomentInclude: [getCmID('koxEPC')] },
                { name: 'epc_entretenimiento', formula: 'count-number', criticalMomentInclude: [getCmID('koxEPC')] },
            ],
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxEPC'), getCmID('Usabilidad'), getCmID('Estatico')])
            },
        }),

        getJacCustomerJourney({
            id: 'cj-ESC',
            title: 'Estático segundo contacto',
            size: [4, 2],
            indicators: [
                { name: 'CSATCONTACTO', formula: 'count-number', criticalMomentInclude: [getCmID('koxESC')] },
                { name: 'esc_seguridad', formula: 'count-number', criticalMomentInclude: [getCmID('koxESC')] },
                { name: 'esc_tecnologia', formula: 'count-number', criticalMomentInclude: [getCmID('koxESC')] },
                { name: 'esc_generales', formula: 'count-number', criticalMomentInclude: [getCmID('koxESC')] },
            ],
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxESC'), getCmID('Usabilidad'), getCmID('Estatico')])
            },
        }),

        getJacCustomerJourney({
            id: 'cj-DPC',
            title: 'Dinámico primer contacto',
            size: [4, 2],
            indicators: [
                { name: 'CSATCONTACTO', formula: 'count-number', criticalMomentInclude: [getCmID('koxDPC')] },
                { name: 'dpc_potencia', formula: 'count-number', criticalMomentInclude: [getCmID('koxDPC')] },
                { name: 'dpc_transmision', formula: 'count-number', criticalMomentInclude: [getCmID('koxDPC')] },
                { name: 'dpc_frenado', formula: 'count-number', criticalMomentInclude: [getCmID('koxDPC')] },
                { name: 'dpc_ruido_vibracion', formula: 'count-number', criticalMomentInclude: [getCmID('koxDPC')] },
            ],
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxDPC'), getCmID('Usabilidad'), getCmID('Dinamico')])
            },
        }),

        getJacCustomerJourney({
            id: 'cj-DSC',
            title: 'Dinámico segundo contacto',
            size: [4, 2],
            indicators: [
                { name: 'CSATCONTACTO', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
                { name: 'dsc_operacion', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
                { name: 'dsc_confort', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
            ],
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxDSC'), getCmID('Usabilidad'), getCmID('Dinamico')])
            },
        }),

        getJacCustomerJourney({
            id: 'cj-Atributos-Carga',
            title: 'Atributos de carga',
            size: [2, 2],
            indicators: [
                { name: 'carga_consumo_est', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
                { name: 'carga_comodidad_est', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
                { name: 'carga_velocidad_est', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] }

            ],
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxDSC'), getCmID('Usabilidad'), getCmID('Dinamico')])
            },
        }),
        getJacCustomerJourney({
            id: 'cj-rendimiento',
            title: 'Rendimiento del vehículo',
            size: [2, 2],
            indicators: [
                { name: 'rango_autonomiabat_est', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
                { name: 'rango_consumocon_est', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] },
                { name: 'rango_autonomiatot_est', formula: 'count-number', criticalMomentInclude: [getCmID('koxDSC')] }
            ],
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxDSC'), getCmID('Usabilidad'), getCmID('Dinamico')])
            },
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'rankingByQuestionBest',
            title: 'widgets.bestRotativasKOX',
            size: [2, 2],
            indicator: 'rotativas',
            extras: {
                trunc: 'HALF_DOWN',
                topSize: 3,
                groupBy: 'question',
            },
            extraIndicatorConfigs: {
                limit: 5
            },
            extraConfigs: {
                fontSize: '20px',
                rankingType: 'comparative'
            },
            criticalMomentInclude: [getCmID('Usabilidad')],
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'rankingByQuestionWorst',
            title: 'widgets.worstRotativasKOX',
            size: [2, 2],
            indicator: 'rotativas',
            extras: {
                trunc: 'HALF_DOWN',
                topSize: 3,
                groupBy: 'question'
            },
            extraIndicatorConfigs: {
                limit: 5
            },
            extraConfigs: {
                fontSize: '20px',
                color: '#DB7476',
                rankingType: 'comparative'
            },
            criticalMomentInclude: [getCmID('Usabilidad')],
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'diagramaIshikawa',
            title: 'widgets.ishikawa',
            size: [4, 2],
            indicator: 'SENTIMENT',
            criticalMomentInclude: [getCmID('Usabilidad')],
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: "widgets.sentimentAnalysis",
            size: [4, 3],
            indicator: 'SENTIMENT',
            criticalMomentInclude: [getCmID('Usabilidad')],
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: '5 características o funciones que más gustan del vehículo',
            size: [2, 3],
            indicator: 'cuarto_contacto_cinco_likes',
            extraConfigs: {
                tagsLimit: 50
            },
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxDSC'), getCmID('Usabilidad'), getCmID('Dinamico')])
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: '5 características o funciones que más disgustan del vehículo',
            size: [2, 3],
            indicator: 'cuarto_contacto_cinco_unlikes',
            extraConfigs: {
                tagsLimit: 50
            },
            render: (filters: FiltersUI) => {
                return renderForCriticalMoment(filters, [getCmID('koxDSC'), getCmID('Usabilidad'), getCmID('Dinamico')])
            },
        }),

    ],
} as DasboardConfig
